
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class MultiSelect extends Vue {
	@Prop({ type: Array, default: () => [] }) public value!: string[];
	@Prop({ type: Array, required: true }) public options!: string[];
	@Prop({ type: String, required: true, default: '' }) public inputId!: string;
	@Prop({ type: String, default: '' }) public placeholder!: string;
	@Prop({ type: String, required: true }) public summaryKey!: string;
	@Prop({ type: Boolean, default: false }) public hasError!: boolean;
	@Prop({ type: Boolean, default: false }) public clearable!: boolean;
	@Prop({ type: Boolean, default: false }) public searchable!: boolean;
	@Prop({ type: Boolean, default: false }) public taggable!: boolean;
	@Prop({ type: Boolean, default: false }) public disabled!: boolean;

	private get selectedValues(): string[] {
		return this.value || [];
	}

	private set selectedValues(values: string[]) {
		this.$emit('input', values);
	}

	private get selectedCount(): number {
		return this.value?.length || 0;
	}

	private get selectionSummary(): string {
		const count = this.selectedCount;

		if (count === 0) {
			return this.placeholder;
		}

		return this.$tc(this.summaryKey, count, { count });
	}

	private isItemSelected(item: string): boolean {
		return this.value?.includes(item) || false;
	}

	private handleOptionClick(slotProps: any): void {
		const option = slotProps.option || slotProps.label;
		const currentValue = [...(this.value || [])];
		const isSelected = currentValue.includes(option);

		if (isSelected) {
			const newValue = currentValue.filter(item => item !== option);
			this.$emit('input', newValue);
		}
		else {
			const newValue = [...currentValue, option];
			this.$emit('input', newValue);
		}
	}
}
